import AnchorLink from './AnchorLink';
export default AnchorLink;

